import React from 'react';
import { Star, CheckCircle } from 'lucide-react';
const featuredTestimonial = {
  name: 'Valentina M.',
  location: 'Córdoba',
  quote: 'En 3 días mi hijo durmió solo por primera vez en 2 años. El protocolo de miedos es exactamente lo que necesitábamos.'
};
export function TestimonialsCarousel() {
  return <section className="py-12 bg-charcoal" data-id="element-370">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-371">
        <div className="bg-night-light rounded-xl p-6 md:p-8 shadow-md border-l-4 border-l-gold border-y border-r border-white/10 relative" data-id="element-372">
          <div className="flex text-gold mb-4" data-id="element-373">
            {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-current" data-id="element-374" />)}
          </div>
          <p className="text-gray-100 text-lg md:text-xl font-medium leading-relaxed mb-6" data-id="element-375">
            "{featuredTestimonial.quote}"
          </p>
          <div className="flex items-center gap-3" data-id="element-376">
            <div className="w-12 h-12 rounded-full bg-night-lighter flex items-center justify-center text-gold font-serif font-bold text-xl" data-id="element-377">
              VM
            </div>
            <div data-id="element-378">
              <div className="flex items-center gap-1.5" data-id="element-379">
                <p className="text-base font-bold text-white" data-id="element-380">
                  {featuredTestimonial.name}
                </p>
                <CheckCircle className="w-4 h-4 text-green-500" data-id="element-381" />
              </div>
              <p className="text-sm text-gray-400" data-id="element-382">
                {featuredTestimonial.location} • Compra verificada
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}